export enum RunType {
  Regular = 'regular',
  AddDocs = 'addDocs',
  AddDocsUpdateSynopsis = 'addDocsUpdateSynopsis',
  UpdateSynopsis = 'updateSynopsis',
  UpdateInconsistencies = 'updateInconsistencies',
  DeleteDocuments = 'deleteDocuments',
  Reprocess = 'reprocess',
}

/**
 * Run types that uploaded and processed actual documents. Only these are eligible
 * for the "Rerun failed jobs" feature — synopsis/inconsistency/delete runs have
 * no per-doc processing state to retry.
 */
export const REPROCESSABLE_RUN_TYPES: readonly RunType[] = [
  RunType.Regular,
  RunType.AddDocs,
  RunType.AddDocsUpdateSynopsis,
] as const;

/** Run types that carry no documents and write no pipeline manifest. */
export const METADATA_ONLY_RUN_TYPES: readonly RunType[] = [
  RunType.UpdateSynopsis,
  RunType.DeleteDocuments,
] as const;
